import React, { useEffect } from 'react'
import { constants } from 'mage-deps/@klarna/bubble-ui'
import { selectors as configSelectors } from 'mage-config'
import { selectors as coreSelectors, hooks as coreHooks } from 'mage-core'
import { thunks as stateThunks, selectors as stateSelectors } from 'mage-state'
import { hooks } from 'mage-i18n'
import Script from 'react-load-script'
import { useDispatch, useSelector } from 'react-redux'
import { useEducationFeatures } from 'education-tools'

const { Colors, Fonts } = constants

export default function FreshChatWidget () {
  const t = hooks.useTranslator()
  const client = useSelector(coreSelectors.clientFactory)('/api/conversation')
  const selectedMid = useSelector(coreSelectors.getSelectedMid)
  const env = useSelector(configSelectors.environment)
  const freshChatConfig = useSelector(stateSelectors.freshChatConfig)
  const features = useEducationFeatures()
  const dispatch = useDispatch()

  const tokenHelper = coreHooks.useTokenHelper()
  const userInfo = {
    givenName: tokenHelper.getGivenName(),
    familyName: tokenHelper.getFamilyName(),
    email: tokenHelper.getEmail(),
    merchantIds: tokenHelper.getMids(),
    resourceAccess: tokenHelper.getAllPermissions()
  }

  function getSettings () {
    return {
      token: freshChatConfig.token,
      host: freshChatConfig.host,
      config: {
        agent: {
          hidePic: true,
          hideName: true,
          hideBio: true
        },
        headerProperty: {
          hideChatButton: true,
          appName: 'Klarna',
          appLogo: 'https://a.klarnacdn.net/klapp/assets/support-chat/klarna_logo.png',
          backgroundColor: Colors.BLACK.toString(),
          foregroundColor: Colors.WHITE.toString(),
          backgroundImage: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII=',
          fontName: Fonts.KLARNA_HEADLINE_REGULAR.fontFamily
        },
        content: {
          headers: {
            chat: t('conversation.widget.title'),
            chat_help: ' ' // don't show 'Reach out to us if you have any questions'
          }
        }
      }
    }
  }

  useEffect(() => {
    if (window.fcWidget) {
      window.fcWidget.destroy()
    }
  }, [])

  if (env === 'playground') {
    return null
  }
  return (
    <Script
      url={freshChatConfig.widget}
      onError={() => console.error('Error loading FreshChat widget')}
      onLoad={() => dispatch(stateThunks.initWidget(client, selectedMid, getSettings(), userInfo, features))}
    />
  )
}
